// extracted by mini-css-extract-plugin
export default {"topDetails":"TopDetailsWrapper_topDetails__iWlIQ"};